import React, { Component } from "react";
import { connect } from "react-redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ScrollContainer from "react-indiana-drag-scroll";
import posed from "react-pose";
import moment from "moment";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const ShakePose = posed.div({
  shake: {
    applyAtEnd: { x: 0 },
    applyAtStart: { x: -10 },
    x: 0,
    transition: {
      type: "spring",
      stiffness: 1000,
      damping: 10,
      duration: 4,
    },
  },
});
class ProductBookingSlot2 extends Component {
  constructor(props) {
    super(props);
    this.Dates_Container = React.createRef();
    this.Times_Container = React.createRef();
  }

  state = {
    selectedDate: -1,
    selectedTime: -1,
    ScrollAbleDate: false,
    ScrollAbleTime: false,
    error: false,
  };

  SetBookingError = () => {
    this.setState({ error: true });
  };

  ar_days = {
    Sun: "اﻷحد",
    Mon: "اﻷثنين",
    Tue: "الثلاثاء",
    Wed: "اﻷربعاء",
    Thu: "الخميس",
    Fri: "الجمعة",
    Sat: "السبت",
  };
  ar_months = {
    Jan: "يناير ",
    Feb: "فبراير",
    Mar: "مارس",
    Apr: "أبريل",
    May: "مايو",
    Jun: "يونيو",
    Jul: "يوليو",
    Aug: "أغسطس",
    Sep: "سبتمبر",
    Oct: "أكتوبر",
    Nov: "نوفمبر",
    Dec: "ديسمبر",
  };

  removeDups = (names) => {
    let unique = {};
    names.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true;
      }
    });
    return Object.keys(unique);
  };
  check_out_of_stock = (date) => {
    let mydate = this.formatDate(this.dates[date]);
    let Times = this.props.slots.filter(
      (date) => date.date === mydate && date.inventory > 0
    );
    if (Times.length) return true;
    return false;
  };

  removeEmpty = (date, i) => {
    let mydate = this.formatDate(date);
    let Times = this.props.slots.filter(
      (date) => date.date === mydate && date.inventory > 0
    );

    if (Times.length) return false;

    this.dates.splice(i, 1);

    return true;
  };
  handleDateChange = (date) => {
    let selectedTime = -1;
    let newError = this.state.error;
    if (date !== this.state.selectedDate) {
      let mydate = this.formatDate(this.dates[parseInt(date)]);

      let Times = this.props.slots.filter((date) => date.date === mydate);

      if (Times.length === 1) {
        selectedTime = Times[0].id;
        newError = false;
      }

      this.props.SetBookingSlot(selectedTime);
      this.setState({
        selectedDate: parseInt(date),
        selectedTime: selectedTime,
        error: newError,
      });
    }
  };
  handleTimeChange = (Time, id) => {
    if (id !== this.state.selectedTime) {
      this.props.SetBookingSlot(id);
      this.setState({
        selectedTime: id,
        error: false,
      });
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.current_product.id !== this.props.current_product.id) {
      this.setUpBookingSlots(true);
    }
    if (this.Dates_Container.current && this.Times_Container.current) {
      let CheckScrollAbleDate =
        this.Dates_Container.current.container.current.scrollWidth >
        this.Dates_Container.current.container.current.clientWidth;
      let CheckScrollAbleTime =
        this.Times_Container.current.container.current.scrollWidth >
        this.Times_Container.current.container.current.clientWidth;
      if (
        CheckScrollAbleDate !== this.state.ScrollAbleDate ||
        CheckScrollAbleTime !== this.state.ScrollAbleTime
      ) {
        this.setState({
          ScrollAbleDate: CheckScrollAbleDate,
          ScrollAbleTime: CheckScrollAbleTime,
        });
      }
    }
    if (this.props.current_product.service_booking_style === "calendar") {
      if (prevProps.selectedDate != this.props.selectedDate) {
        let selectedTime = -1;
        let Times = this.props.slots.filter(
          (date) => date.date === this.props.selectedDate
        );

        if (Times.length === 1) {
          selectedTime = Times[0].id;
          this.props.SetBookingSlot(selectedTime);
        }
        this.setState({ selectedTime: selectedTime });
      }
    }
  }
  setUpBookingSlots(errorFuncionSet = false) {
    this.dates = this.removeDups(
      this.props.slots.map((date) => this.toDate(date.date))
    );

    this.dates.forEach((date, i) => this.removeEmpty(date, i));
    for (let i = 0; i < this.dates.length; i++) {
      if (this.removeEmpty(this.dates[i], i)) i -= 1;
    }

    if (this.dates.length) {
      this.props.SetBookingSlot(
        this.props.slots.find((slot) => slot.inventory !== 0).id
      );

      this.props.SetBookingSlot(-1);
    } else {
      this.props.SetBookingSlot("Out");
    }

    if (!errorFuncionSet) {
      this.props.SetBookingError(() => this.SetBookingError());
    }
    this.setState({
      selectedDate: -1,
    });
  }
  componentDidMount() {
    this.setUpBookingSlots();
  }
  toDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");

    return new Date(year, month - 1, day);
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  translateSlotText = (text) => {
    const { language } = this.props;
    if (language == "english") return text;

    let temp = text.replace(/PM/g, "م");
    temp = temp.replace(/AM/g, "ص");
    return temp;
  };
  render() {
    let DateItems = [];
    let Times = [];
    let dateError = false;
    let timeError = false;
    if (this.state.error) {
      if (this.state.selectedDate === -1) {
        dateError = true;
      } else {
        timeError = true;
      }
    }
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";

    const { language, customTexts, current_product } = this.props;
    if (this.dates) {
      DateItems = this.dates.map((date, i) => {
        date = date.split(" ");
        return language === "english" ? (
          <span
            key={i}
            className={` pointer mx-4 ${
              this.state.selectedDate === i ? "active" : ""
            }`}
            onClick={() => this.handleDateChange(i)}
            style={{
              color: this.state.selectedDate === i && themeColor,
              border: `1px solid ${
                this.state.selectedDate === i ? themeColor : "#99999999"
              }`,
              borderRadius: 5,
              padding: 15,
            }}
          >
            {`${date[0]}  ${parseInt(date[2], 10)}  ${date[1]}`}
          </span>
        ) : (
          <span
            key={i}
            className={` pointer mx-4 ${
              this.state.selectedDate === i ? "active" : ""
            }`}
            onClick={() => this.handleDateChange(i)}
            style={{
              color: this.state.selectedDate === i && themeColor,
              border: `1px solid ${
                this.state.selectedDate === i ? themeColor : "#99999999"
              }`,
              borderRadius: 5,
              padding: 15,
            }}
          >
            {`${this.ar_days[date[0]]}  ${parseInt(date[2], 10)} ${
              this.ar_months[date[1]]
            }`}
          </span>
        );
      });

      let mydate = this.formatDate(this.dates[this.state.selectedDate]);
      if (current_product.service_booking_style == "calendar") {
        mydate = this.props.selectedDate;
      }
      Times = this.props.slots
        .filter((date) => date.date === mydate && date.inventory > 0)
        .map((time, i) => (
          <span
            key={i}
            value={time.id}
            onClick={() => this.handleTimeChange(i, time.id)}
            className={` pointer mx-4 ${
              this.state.selectedTime === time.id ? "active" : ""
            }`}
            style={{
              color: this.state.selectedTime === time.id && themeColor,
              border: `1px solid ${
                this.state.selectedTime === time.id ? themeColor : "#99999999"
              }`,
              borderRadius: 5,
              padding: 15,
              direction: language == "english" ? "ltr" : "rtl",
            }}
          >
            {this.translateSlotText(
              `${moment(time.start, "HH:mm").format("h:mm A")} - ${moment(
                time.end,
                "HH:mm"
              ).format("h:mm A")}`
            )}
          </span>
        ));
    }

    if (this.dates && this.dates.length)
      return (
        <div
          id="BookingSlots"
          className={
            current_product.service_booking_style === "scroll" &&
            "border-top border-bottom"
          }
          style={{ width: "100%", backgroundColor: "white" }}
        >
          {current_product.service_booking_style === "scroll" && (
            <>
              {" "}
              <ShakePose
                pose={[`${dateError ? "shake" : ""}`]}
                poseKey={dateError === false}
              >
                <h4
                  className={`mt-4  ${
                    language === "english" ? "text-left" : "text-right"
                  } mx-4`}
                  style={{
                    fontFamily: language == "english" ? "Quicksand" : "Cairo",
                    color: dateError ? "red" : "",
                    fontSize: 14,
                  }}
                >
                  {`${
                    language === "english"
                      ? customTexts.bookables_select_date
                      : customTexts.bookables_select_date_ar
                  }`}
                </h4>
              </ShakePose>
              <div
                className={`d-flex mt-4 border-top border-bottom mx-auto align-items-center ${
                  this.state.ScrollAbleDate
                    ? "justify-content-start"
                    : "justify-content-center"
                }   `}
                style={{
                  width: "90%",
                  heigth: "70px",
                  color: "#999",
                  fontSize: "15px",
                  fontFamily: "",
                  fontWeight: "600",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                <div style={{ height: "auto" }}>
                  {this.state.ScrollAbleDate && (
                    <ArrowBackIosIcon
                      className="pointer"
                      onClick={() =>
                        (this.Dates_Container.current.container.current.scrollLeft +=
                          -100)
                      }
                    />
                  )}
                </div>
                <ScrollContainer
                  className={` d-flex  py-3   ${
                    language === "arabic" ? "flex-row-reverse" : ""
                  }`}
                  ref={this.Dates_Container}
                >
                  {DateItems}
                </ScrollContainer>
                {this.state.ScrollAbleDate && (
                  <div style={{ height: "auto" }}>
                    <ArrowForwardIosIcon
                      className="ml-1 my-auto pointer"
                      onClick={() =>
                        (this.Dates_Container.current.container.current.scrollLeft += 100)
                      }
                    />
                  </div>
                )}
              </div>
            </>
          )}
          <ShakePose
            pose={[`${timeError ? "shake" : ""}`]}
            poseKey={timeError === false}
          >
            {" "}
            <h4
              className={`mt-4  ${
                language === "english" ? "text-left" : "text-right"
              } mx-4`}
              style={{
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
                color: timeError ? "red" : "",
                fontSize: 14,
              }}
            >
              {`${
                language === "english"
                  ? customTexts.bookables_select_time
                  : customTexts.bookables_select_time_ar
              }`}
            </h4>
          </ShakePose>
          <div
            className={`mt-4 mx-auto align-items-center ${
              current_product.service_booking_style == "scroll"
                ? "mb-5"
                : "mb-4"
            } ${
              this.state.ScrollAbleTime
                ? "justify-content-start"
                : "justify-content-center"
            } 
           `
              .concat(
                current_product.service_booking_style === "scroll"
                  ? " border-top border-bottom"
                  : ""
              )
              .concat(current_product.time_slots_style === 0 ? " d-flex" : "")}
            style={{
              width: "90%",
              heigth: "70px",
              color: "#999",
              fontSize: "15px",
              fontFamily: "",
              fontWeight: "600",
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            {current_product.time_slots_style === 0 && (
              <div style={{ height: "auto" }}>
                {((current_product.service_booking_style === "calendar" &&
                  this.props.selectedDate &&
                  Times.length > 1) ||
                  (current_product.service_booking_style === "scroll" &&
                    this.state.ScrollAbleTime &&
                    this.state.selectedDate !== -1)) && (
                  <ArrowBackIosIcon
                    className="pointer"
                    onClick={() =>
                      (this.Times_Container.current.container.current.scrollLeft +=
                        -100)
                    }
                  />
                )}
              </div>
            )}
            {current_product.time_slots_style === 0 && (
              <ScrollContainer
                className={` d-flex  py-3 ${
                  language === "arabic" ? "flex-row-reverse" : ""
                } `}
                ref={this.Times_Container}
              >
                {Times.length
                  ? Times
                  : language === "english"
                  ? "Select your date first"
                  : "يجب إختيار التاريخ اولا"}
              </ScrollContainer>
            )}
            {current_product.time_slots_style === 1 &&
              (!Times.length ? (
                language === "english" ? (
                  "Select your date first"
                ) : (
                  "يجب إختيار التاريخ اولا"
                )
              ) : (
                <>
                  <div style={{ maxHeight: 200, overflowY: "scroll" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "auto",
                        justifyContent: "center",
                        rowGap: 20,
                        padding: Times.length > 3 && "5px 0px",
                      }}
                    >
                      {Times}
                    </div>
                  </div>

                  {Times.length > 3 ? (
                    <div
                      className="text-center"
                      style={{
                        position: "relative",
                        bottom: -2,
                        background: "white",
                      }}
                    >
                      <KeyboardArrowDownIcon style={{ color: "#7D7D7D" }} />
                    </div>
                  ) : (
                    <div style={{ marginBottom: 21, width: "100%" }}></div>
                  )}
                </>
              ))}
            {current_product.time_slots_style === 0 &&
              ((current_product.service_booking_style === "calendar" &&
                this.props.selectedDate &&
                Times.length > 1) ||
                (current_product.service_booking_style === "scroll" &&
                  this.state.ScrollAbleTime &&
                  this.state.selectedDate !== -1)) && (
                <div style={{ height: "auto" }}>
                  <ArrowForwardIosIcon
                    style={{}}
                    className="ml-1 my-auto pointer"
                    onClick={() =>
                      (this.Times_Container.current.container.current.scrollLeft += 100)
                    }
                  />
                </div>
              )}
          </div>
        </div>
      );
    else return null;
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    themeColor: state.store.store.settings.dark,
    customTexts: state.store.store.settings.custom_texts,
  };
};

export default connect(mapStateToProps)(ProductBookingSlot2);
